module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/banking-18af38c965074d02611dd8570c3b4fad.svg";